<template>
    <div class="t_dropdown">
        <div class="t_dropdown__label" @click.stop="showDropdown = !showDropdown">
            <span class="subtitle text-primary">{{ label }}</span> <img class="t_dropdown__arrow" v-bind:class="{ t_up: showDropdown }" src="/img/dropdown-arrow.svg" alt="">
        </div>
        <div class="t_dropdown__menu" v-bind:class="{ t_show: showDropdown }" v-if="showDropdown" v-click-outside="onClickOutside">
            <template v-if="show_pricing">
            <a @click.prevent="upgradePlan()"><p>{{ $t('dashboard.upgrade_plan') }}</p></a>
            </template>
            <a href="/account"><p>{{ $t('dashboard.account_settings') }}</p></a>
            <template v-if="!plan_ended">
            <a href="/pixel"><p>{{ $t('dashboard.facebook_pixel') }}</p></a>
            </template>
            <a @click.prevent="contactSupport()"><p>{{ $t('dashboard.contact_support') }}</p></a>
            <a @click.prevent="logout()"><p>{{ $t('dashboard.logout') }}</p></a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            label: String,
            csrf: String,
            plan_ended: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                show_pricing: SHOW_PRICING,
                showDropdown: false
            }
        },
        methods: {
            onClickOutside() {
                if (this.showDropdown) {
                    this.showDropdown = false;
                }
            },
            logout() {
                const url = '/logout';
                    return axios.post(url)
                        // get data
                        .then(function (response) {
                            window.location.href = "/";
                        }.bind(this));
            },
            contactSupport() {
                drift.on('ready', function(driftApi) {
                    driftApi.sidebar.open();
                })
            },
            upgradePlan() {
                if (typeof mixpanel === 'object') {
                    mixpanel.track("Clicked on Upgrade a plan");
                }

                window.location.href = "/choose-a-plan";
            }
        }
    }
</script>